export enum LocalStorageKey {
    AuthToken = "authToken",
    ClientId = "clientId",
    ExperimentData = "experimentData",
    Sources = "sources",
}
